<div mat-dialog-content class="auth-license-renewal-dialog">
  <h1>{{ 'label_action_required' | translate }}</h1>
  <p>{{ 'upcoming_license_renewal' | translate }}</p>
  <p [innerHTML]="data.settingLicenseRenewal"></p>
  <button mat-stroked-button color="primary" [disableRipple]="true">
    {{ 'label_autoclose_in_seconds' | translate : { counter: counter } }}
  </button>
</div>
